import React, { useState } from 'react';
import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  InputGroup,
  InputLeftElement,
  VStack,
  Image,
  Link,
  Input,
  Heading,
  Text,
  useToast,
  Container,
  Icon,
  Badge,
  HStack
} from '@chakra-ui/react';
import { LockIcon, CheckCircleIcon } from '@chakra-ui/icons';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import PinInput from '../shared/PinInput';
import Header from '../layout/Header';
import Footer from '../layout/Footer';

const MotionBox = motion(Box);

const ResetPasswordPage = () => {
  const [code, setCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [resetDone, setResetDone] = useState(false);
  const toast = useToast();
  const navigate = useNavigate();

  const primaryColor = '#F2C919';
  const secondaryColor = '#2C3E50';
  const bgColor = 'gray.50';

  const handleSubmit = (e) => {
    e.preventDefault();
    if (code.length < 4 || !newPassword) {
      toast({
        title: "خطأ",
        description: "الرجاء إدخال الرمز وكلمة المرور الجديدة.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    setResetDone(true);
    toast({
      title: 'تمت إعادة تعيين كلمة المرور بنجاح',
      description: "يمكنك الآن تسجيل الدخول بكلمة المرور الجديدة.",
      status: 'success',
      duration: 5000,
      isClosable: true,
      position: 'top'
    });

    setTimeout(() => {
      navigate('/login');
    }, 2000);
  };

  return (
    <Box minH="100vh" bg={bgColor} dir="rtl">
      <Header />

      <Container maxW="container.md" py={{ base: 12, md: 24 }}>
        <VStack spacing={8} align="center">
          <VStack spacing={4} textAlign="center">
            <Badge bg={primaryColor} color={secondaryColor} px={4} py={1} borderRadius="full" fontSize="sm" fontWeight="800" fontFamily="Tajawal, sans-serif">
              تصفير الحساب
            </Badge>
            <Heading fontSize={{ base: '3xl', md: '4xl' }} fontFamily="Tajawal, sans-serif" fontWeight="900" color={secondaryColor}>
              إعادة تعيين كلمة المرور
            </Heading>
            <Text fontSize="lg" fontFamily="Tajawal, sans-serif" color="gray.600" maxW="450px">
              أدخل الرمز المرسل إليك وكلمة المرور الجديدة لاستعادة الوصول الكامل.
            </Text>
          </VStack>

          <Box
            w="full"
            maxW="550px"
            bg="white"
            p={{ base: 8, md: 12 }}
            borderRadius="3xl"
            boxShadow="2xl"
            border="2px solid"
            borderColor="gray.100"
          >
            <VStack spacing={8} align="stretch">
              <FormControl isRequired>
                <FormLabel fontFamily="Tajawal, sans-serif" fontWeight="700" textAlign="center" mb={6}>
                  رمز التفعيل المؤقت
                </FormLabel>
                <Flex justify="center" dir="ltr">
                  <PinInput value={code} onChange={setCode} length={4} />
                </Flex>
              </FormControl>

              <FormControl isRequired>
                <FormLabel fontFamily="Tajawal, sans-serif" fontWeight="700">كلمة المرور الجديدة</FormLabel>
                <InputGroup>
                  <InputLeftElement h="60px" pointerEvents="none">
                    <LockIcon color="gray.600" />
                  </InputLeftElement>
                  <Input
                    type="password"
                    placeholder="أدخل كلمة المرور الجديدة"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    bg="gray.50"
                    h="60px"
                    borderRadius="xl"
                    border="2px solid"
                    borderColor="transparent"
                    _focus={{ borderColor: primaryColor, bg: 'white' }}
                    fontFamily="Tajawal, sans-serif"
                  />
                </InputGroup>
              </FormControl>

              {resetDone ? (
                <VStack spacing={4} py={4}>
                  <Icon as={CheckCircleIcon} color="green.400" boxSize={16} />
                  <Text fontSize="lg" fontFamily="Tajawal, sans-serif" fontWeight="800" color="green.600">
                    تمت العملية بنجاح!
                  </Text>
                  <Text fontFamily="Tajawal, sans-serif" color="gray.500">
                    سيتم تحويلك لصفحة الدخول خلال لحظات...
                  </Text>
                </VStack>
              ) : (
                <Button
                  bg={primaryColor}
                  color={secondaryColor}
                  h="65px"
                  fontSize="xl"
                  fontWeight="900"
                  fontFamily="Tajawal, sans-serif"
                  borderRadius="xl"
                  boxShadow="lg"
                  w="100%"
                  _hover={{ bg: '#d4b016', transform: 'translateY(-2px)' }}
                  _active={{ transform: 'translateY(0)' }}
                  onClick={handleSubmit}
                >
                  حفظ كلمة المرور الجديدة
                </Button>
              )}

              <Button
                as={RouterLink}
                to="/login"
                variant="ghost"
                color="gray.500"
                fontFamily="Tajawal, sans-serif"
                fontWeight="700"
                _hover={{ color: primaryColor, bg: 'transparent' }}
              >
                إلغاء والعودة للدخول
              </Button>
            </VStack>
          </Box>
        </VStack>
      </Container>

      <Footer />
    </Box>
  );
};

export default ResetPasswordPage;

